import React from "react";
import emailIllustrationLogo from "./EmailIllustrationLogo.svg";

function EmailIllustrationLogoIcon({
  alt = "Email illustration",
  className = "",
  height = 258,
  width = 210,
}) {
  return (
    <img
      alt={alt}
      className={className}
      height={height}
      src={emailIllustrationLogo}
      width={width}
    />
  );
}

export default EmailIllustrationLogoIcon;
